
import { defineComponent, ref } from 'vue'

import useTooltip from '@/modern/composable/useTooltip'
import useClickOutside from '@/modern/composable/useClickOutside'

export default defineComponent({
    setup() {
        const container = ref<HTMLElement | null>(null)

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'left',
            strategy: 'absolute',
            offset: 12,
            autoPlacement: {
                allowedPlacements: ['bottom', 'top', 'left', 'left-start', 'left-end'],
            },
        })

        useClickOutside(container, close)
        
        return {
            container,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            open,
            close
        }
    }
})
